import { type ProgramGuideItem, type PlayItem} from "@ca.vmedia.tv/domains";
import {TimeUtils} from "@/utils";
export class ProgramUtils {

    static isLive(program: ProgramGuideItem | PlayItem): boolean {
        const now = TimeUtils.dateNow();
        const beginTime = program.recentAirTime?.startTime ?? 0;
        const endTime = beginTime + program.length! * 60 * 1000;

        return beginTime <= now && endTime > now;
    }

    static isPast(program: ProgramGuideItem): boolean {
        const now = TimeUtils.dateNow();
        const beginTime = program.recentAirTime!.startTime!;
        const endTime = beginTime + program.length! * 60 * 1000;

        return endTime <= now;
    }

    static isFuture(program: ProgramGuideItem): boolean {
        const now = TimeUtils.dateNow();
        const beginTime = program.recentAirTime!.startTime!;

        return beginTime > now;
    }

    super() {
        return this;
    }
}
